// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WzaXI","clinicsSelect":"styles_clinicsSelect__1Dyid"};